export default __webpack_public_path__ + "static/media/Pramath.9fd4f560.jpg";